import {ClickOutsideDirective} from "./click-outside.directive";
import {HasRolesDirective} from "./has-roles.directive";

export const DIRECTIVES = [
    ClickOutsideDirective,
    HasRolesDirective
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/directives/index.ts